export class McpTool {
  public name: string;
  public url: string;
  public authorizationToken?: string;
  public isEnabled: boolean;

  public constructor(data: any) {
    this.name = data.name;
    this.url = data.url;
    this.authorizationToken = data.authorizationToken;
    this.isEnabled = data.isEnabled;
  }
}
